import type { ReactElement } from "react";

import { Icon } from "@/components/Icon";
import type { TextInputIconProps } from "@/types";
import { mergeSx } from "@/utils";

import { inputIconBaseSx } from "./styles";

export function TextInputIcon<RC extends ReactElement | undefined>({
  sx,
  ...props
}: TextInputIconProps<RC>) {
  const allStyles = mergeSx(inputIconBaseSx, sx);
  return <Icon {...props} sx={allStyles} />;
}

TextInputIcon.displayName = "TextInput.Icon";
